import {LinearSelectorClickEvent, WhitelabelEvent} from "../../events/Events";
import {EventBus} from "../../events/EventBus";

const eventBus: EventBus = EventBus.getInstance();
const inputs: Array<HTMLInputElement> = Array.from(document.querySelectorAll('.js-wl-linear-selector-filter-input'));

eventBus.subscribe(LinearSelectorClickEvent.TYPE, (event: WhitelabelEvent) => {
    const clickEvent: LinearSelectorClickEvent = event as LinearSelectorClickEvent;
    inputs
        .filter((input: HTMLInputElement) : boolean => input.name === clickEvent.payload.inputName)
        .forEach((input: HTMLInputElement) => {
            if (input.value === clickEvent.payload.inputValue) {
                input.checked = clickEvent.payload.inputChecked;
            } else {
                input.checked = false;
            }
        });
});

inputs.forEach((input: HTMLInputElement) => {
    input.addEventListener('click', () => {
        eventBus.emit(new LinearSelectorClickEvent({
            inputName: input.name,
            inputValue: input.value,
            inputChecked: input.checked
        }));
    });
});